<unity-dropdown-clickable-control
  sortBy="user_name"
  textField="full_name"
  linkRoot="/user"
  [selectable]="$selectable()"
  [control]="$control()"
  [displayName]="$displayName()"
  [description]="$description()" />
